export const COLOR_PRIMARY = '#142851';
export const COLOR_INPUT = '#F0F0F0';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_DARK = '#505050';
export const COLOR_DRIVERS = '#F5F9FF';
export const COLOR_ERROR = '#D80000';
export const COLOR_SELECT_PLACEHOLDER = '#6C757D';
export const COLOR_INACTIVE_BACKGROUND = '#D3D3D3';
export const COLOR_SPINNER = '#142851';
